var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 14.1666C8.98351 14.1666 8.09795 13.8508 7.34073 13.2191C6.58351 12.5875 6.10795 11.7922 5.91406 10.8333H1.66406V9.16665H5.91406C6.10851 8.20831 6.58434 7.41304 7.34156 6.78081C8.09878 6.14859 8.98406 5.83276 9.9974 5.83331C11.0113 5.83331 11.8968 6.14915 12.6541 6.78081C13.4113 7.41248 13.8868 8.20776 14.0807 9.16665H18.3307V10.8333H14.0807C13.8863 11.7916 13.4107 12.5869 12.6541 13.2191C11.8974 13.8514 11.0118 14.1672 9.9974 14.1666ZM9.9974 12.5C10.6918 12.5 11.2821 12.2569 11.7682 11.7708C12.2543 11.2847 12.4974 10.6944 12.4974 9.99998C12.4974 9.30554 12.2543 8.71526 11.7682 8.22915C11.2821 7.74304 10.6918 7.49998 9.9974 7.49998C9.30295 7.49998 8.71267 7.74304 8.22656 8.22915C7.74045 8.71526 7.4974 9.30554 7.4974 9.99998C7.4974 10.6944 7.74045 11.2847 8.22656 11.7708C8.71267 12.2569 9.30295 12.5 9.9974 12.5Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommits);
export default __webpack_public_path__ + "static/media/Commits.c7e33bfcafd90ef094739f67b7d0685e.svg";
export { ForwardRef as ReactComponent };